import { Icon } from '../../../@paco/components'
import { ElementWithTooltip } from '../../../@paco/compositions'
import { Setting } from '../../../@paco/entities/Setting/Setting'
import { getAbnormalTrackDurationThresholdSettingValue } from '../../../@paco/entities/Setting/SettingHelpers'
import { Track } from '../../../@paco/entities/Track/Track'
import trans from '../../../@paco/helpers/trans'

import InfoCircle from '../../../components/InfoCircle/InfoCircle'
import {
    getIconById,
    getIconByMeal,
    getIconBySatisfaction,
    getObjProperty,
    getUserFullName,
} from '../../../helpers'
import transformTimeStringToNumber from '../../../helpers/date/transformTimeStringToNumber'
import { translate } from '../../../helpers/translations/translator'
import { TrackViewModel } from '../../../models'
import { transformBillableTimeToHourMinutes } from '../../../services/TrackService/getTotalBillableTimeFromTracks'
import ExclamationMarkBadge from '../compositions/ExclamationMarkBadge'
import { getTrackAssessorTooltip, getTrackSatisfactionTooltip } from './index'

export function renderInfoCircles(track: Track, canViewSatisfaction: boolean, canViewSatisfactionFeedback: boolean) {
    const feedbackRemark = canViewSatisfactionFeedback && getObjProperty(track, 'feedback.rating.remark')

    return (
        <>
            <InfoCircle
                text={track.pause}
                tooltip={`${track.pause} ${translate('pages.tracks.minutesBreakTime')}`}
            />

            <InfoCircle
                icon={getIconByMeal(track.meal)}
                tooltip={track.meal && translate(`pages.tracks.${track.meal.toLowerCase()}`)}
                iconClass={track.meal}
            />

            {track.assessor && (
                <InfoCircle
                    icon={getIconById('tie')}
                    tooltip={getTrackAssessorTooltip(track)}
                />
            )}

            {(track.feedback && canViewSatisfaction) && (
                <InfoCircle
                    icon={getIconBySatisfaction(getObjProperty(track, 'feedback.rating'))}
                    alt={translate('common.satisfaction')}
                    tooltip={feedbackRemark || getTrackSatisfactionTooltip(track)}
                    iconClass="smiley"
                />
            )}

            {(track.deviationRemark || track.unplannedRemark) && (
                <InfoCircle
                    icon={getIconById('remark')}
                    alt={translate('common.comment')}
                    tooltip={`${getUserFullName(track.owner)}: ${track.deviationRemark || track.unplannedRemark}`}
                    iconClass="balloon"
                />
            )}

            {!! track.managerComments?.length && (
                <InfoCircle
                    icon={getIconById('remark')}
                    alt={translate('common.comment')}
                    tooltip={`${getUserFullName(track.managerComments[0].owner)}: ${track.managerComments[0].body}`}
                    iconClass="balloon"
                />
            )}
        </>
    )
}

export const renderWorkedTotalHours = (track: TrackViewModel, settings: Setting[], canViewOfflineTrackIcon: boolean) => {
    const abnormalTrackDurationTreshold = getAbnormalTrackDurationThresholdSettingValue(settings, track.department?.id)
    const totalBillableTime = transformTimeStringToNumber(track.totalBillableTime)
    const isAbnormal = totalBillableTime > abnormalTrackDurationTreshold

    return (
        <span className="tracks__worked-total-hours">
            <div className="tracks__worked-total-hours__text">
                {`${transformBillableTimeToHourMinutes(track.totalBillableTime)} ${translate('common.hour').toLowerCase()} `}
            </div>

            {isAbnormal && <ExclamationMarkBadge className="tracks__worked-total-hours__icon" />}

            {canViewOfflineTrackIcon && track.isOffline && (
                <ElementWithTooltip
                    tooltipIsActive
                    tooltipText={trans('entities.tracks.offlineTrack')}
                    className="tracks__worked-total-hours__tooltip"
                >
                    <Icon name="offline" className="tracks__worked-total-hours__icon" />
                </ElementWithTooltip>
            )}
        </span>
    )
}
